import { JoyField, JoyProperty, JoyObjectType, JoyDataService, JoyDataServiceQueryOption, JoyMedium, JoyUser, isBoolean, isJoyStatusArray, } from 'joy-core';
import JoyDeal from '../objects/JoyDeal';
import JoyPhotosession from '../objects/JoyPhotosession';
export default class JoyDealHelper {
    /**
     * Fetch a Deal document.
     * @param id The identifier of the document to fetch.
     */
    static async get(id) {
        let data = new Map();
        data[JoyField.id] = id;
        data[JoyField.objectType] = JoyObjectType.group;
        let result = await JoyDataService.instance.read(data);
        try {
            return new JoyDeal(result);
        }
        catch (error) {
            throw Error('Invalid input data for JoyDeal');
        }
    }
    /**
     * Remove a Deal document.
     * @param id The identifier of the document to remove.
     */
    static async delete(id) {
        let data = new Map();
        data[JoyField.id] = id;
        data[JoyField.objectType] = JoyObjectType.group;
        await JoyDataService.instance.delete(data);
        return;
    }
    /**
     * Fetch the Photosession documents that belong to this deal.
     * @param dealId The deal that owns the fetched photosessions.
     * @param count Maximum number of documents to retrieve, 0 means all.
     */
    static async getPhotosessions(dealId, count = 0) {
        let data = new Map();
        data[JoyField.objectType] = JoyObjectType.album;
        data[JoyField.group] = dealId;
        data[JoyField.props] = [JoyProperty.photosession, JoyProperty.watermark];
        let options = new Map();
        options[JoyDataServiceQueryOption.limit] = count;
        let result = await JoyDataService.instance.read(data, options);
        let photosessions = [];
        for (const data of result) {
            try {
                photosessions.push(new JoyPhotosession(data));
            }
            catch (error) {
                throw Error('Invalid input for JoyPhotosession.');
            }
        }
        return photosessions;
    }
    /**
     * Fetch the Medium documents that belong to this deal.
     * @param dealId The deal that owns the fetched mediums.
     * @param count Maximum number of documents to retrieve, 0 means all.
     * @param status A JoyStatus value, optional.
     * @param properties An array of JoyProperties, optional.
     * @param isPublic A boolean value indicating if the mediums are public, optional.
     */
    static async getMediums(dealId, count = 0, status, properties, isPublic) {
        let data = new Map();
        data[JoyField.objectType] = JoyObjectType.medium;
        data[JoyField.group] = dealId;
        if (isJoyStatusArray(status)) {
            data[JoyField.status] = status;
        }
        if (properties !== null) {
            data[JoyField.props] = properties;
        }
        if (isBoolean(isPublic)) {
            data[JoyField.isPublic] = isPublic;
        }
        let options = new Map();
        options[JoyDataServiceQueryOption.limit] = count;
        let result = await JoyDataService.instance.read(data, options);
        let mediums = [];
        for (const data of result) {
            try {
                mediums.push(new JoyMedium(data));
            }
            catch (error) {
                throw Error('Invalid input for JoyMedium.');
            }
        }
        return mediums;
    }
    /**
     * Fetch the User documents associated with this deal.
     * @param dealId The deal that owns the fetched users.
     * @param count Maximum number of documents to retrieve, 0 means all.
     * @param properties An array of JoyProperties, optional.
     */
    static async getUsers(dealId, count = 0, properties) {
        let data = new Map();
        data[JoyField.objectType] = JoyObjectType.user;
        data[JoyField.group] = dealId;
        if (properties !== null) {
            data[JoyField.props] = properties;
        }
        let options = new Map();
        options[JoyDataServiceQueryOption.limit] = count;
        let result = await JoyDataService.instance.read(data, options);
        let users = [];
        for (const data of result) {
            try {
                users.push(new JoyUser(data));
            }
            catch (error) {
                throw Error('Invalid input for JoyUser.');
            }
        }
        return users;
    }
}
//# sourceMappingURL=JoyDealHelper.js.map